module.exports = __webpack_public_path__ + "img/picture_as_pdf.a9256a5c.svg";